import marked from 'marked';

export const stringsMixin = {
    methods: {
        formatChatContentForDisplay: function (text) {
            if (!text || typeof text !== 'string' || text.trim() === '') {
                return '';
            }
            let textWithBreaks = text.replace(/\n/g, '<br/>');
            return marked(textWithBreaks);
        },
    }
};